import { action, makeObservable, observable } from 'mobx';

import { BaseStore } from '~/stores/interfaces/BaseStore';

export class MetaStore implements BaseStore {
  isLoading: boolean = false;
  hasError: boolean = false;

  constructor() {
    makeObservable(this, {
      isLoading: observable,
      setLoading: action.bound,
    });
  }

  setLoading(value: boolean): void {
    this.isLoading = value;
  }

  setError(value: boolean): void {
    this.hasError = value;
  }

  destroy() {
    this.setLoading(false);
  }
}
